import logo from '../../assets/images/sarah-sad-01.png';
import { Link } from 'react-scroll';
import { MdEmail } from 'react-icons/md';
// import { SiUpwork } from 'react-icons/si';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaBars } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';

type StateProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Navbar({ open = false, setOpen }: StateProps) {
  return (
    <nav className="bg-tarnsparent backdrop-blur-lg px-4 sm:px-12 py-2.5 sticky w-full z-20 top-0 left-0 shadow-md ">
      <div className="container flex flex-wrap md:flex-row flex-col md:justify-between justify-start md:items-center items-start mx-auto">
        <div className="flex items-center">
          <button
            data-collapse-toggle="navbar-hamburger"
            type="button"
            className=""
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <AiOutlineClose className="text-4xl text-greenish absolute right-8 top-5 cursor-pointer lg:hidden dark:text-beige z-10" />
            ) : (
              <FaBars className="text-4xl text-greenish absolute right-8 top-5 cursor-pointer lg:hidden dark:text-beige" />
            )}
          </button>
          <Link
            to="hero"
            spy={true}
            smooth={true}
            offset={-200}
            delay={50}
            duration={800}
          >
            <img src={logo} alt="logo" className="mr-3 h-12" />
          </Link>
          <div
            className={[
              'items-center justify-between lg:flex lg:w-auto lg:order-1',
              open ? 'flex' : 'hidden',
            ].join(' ')}
          >
            <ul
              className={[
                'text-greenish dark:text-beige font-bold lg:text-xl bg-whitish dark:bg-greenish dark:lg:bg-transparent lg:bg-transparent text-2xl lg:flex flex-col lg:flex-row lg:w-auto lg:h-auto gap-x-5 h-screen w-screen ',
                open
                  ? 'lg:shadow-none flex shadow-xl lg:relative absolute top-0 left-0 lg:p-0 px-5 pt-8  justify-center items-center'
                  : 'left-[-700px] top-[96px] hidden',
              ].join(' ')}
            >
              <li className="lg:py-0 py-2">
                <Link
                  onClick={() => setOpen(false)}
                  to="hero"
                  spy={true}
                  offset={-250}
                  smooth={true}
                  delay={50}
                  duration={800}
                  className="cursor-pointer hover:text-night duration-300 dark:hover:text-whitish"
                >
                  Home
                </Link>
              </li>
              <li className="lg:py-0 py-2">
                <Link
                  to="about"
                  offset={-50}
                  onClick={() => setOpen(false)}
                  spy={true}
                  smooth={true}
                  delay={50}
                  duration={800}
                  className="cursor-pointer hover:text-night duration-300 dark:hover:text-whitish"
                >
                  About
                </Link>
              </li>
              <li className="lg:py-0 py-2">
                <Link
                  to="skills"
                  onClick={() => setOpen(false)}
                  offset={-100}
                  spy={true}
                  smooth={true}
                  delay={50}
                  duration={800}
                  className="cursor-pointer hover:text-night duration-300 dark:hover:text-whitish"
                >
                  Skills
                </Link>
              </li>
              <li className="lg:py-0 py-2">
                <Link
                  to="projects"
                  offset={-100}
                  onClick={() => setOpen(false)}
                  spy={true}
                  smooth={true}
                  delay={50}
                  duration={800}
                  className="cursor-pointer hover:text-night duration-300 dark:hover:text-whitish"
                >
                  Projects
                </Link>
              </li>

              <li className="lg:py-0 py-2">
                <Link
                  to="contact"
                  offset={-100}
                  onClick={() => setOpen(false)}
                  spy={true}
                  smooth={true}
                  delay={50}
                  duration={800}
                  className="cursor-pointer hover:text-night duration-300 dark:hover:text-whitish"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          className={[
            'lg:flex lg:justify-end justify-center gap-x-6 lg:mt-0 mt-3 items-center',
            open ? '' : 'hidden',
          ].join(' ')}
        >
          <a
            href="https://github.com/sarahaboudalal"
            rel="noreferrer"
            target="_blank"
            className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
          >
            <BsGithub className="h-8 w-6" />
          </a>
          <a
            href="https://www.linkedin.com/in/sarah-abou-dalal-977891250/"
            rel="noreferrer"
            target="_blank"
            className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
          >
            <BsLinkedin className="h-8 w-6" />
          </a>
          {/* <a
            href="https://www.upwork.com/freelancers/~01fe1bf223c6b52e3e"
            rel="noreferrer"
            target="_blank"
            className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
          >
            <SiUpwork className="h-8 w-6" />
          </a>
          <a
            href="https://www.behance.net/sarahaboudalal"
            rel="noreferrer"
            target="_blank"
            className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
          >
            <FaBehanceSquare className="h-8 w-6" />
          </a> */}
          <a
            href="mailto:sarahaboudalal@gmail.com"
            className="text-sm font-medium hover:text-night text-greenish duration-300 dark:text-beige dark:hover:text-whitish"
          >
            <MdEmail className="h-8 w-6" />
          </a>
        </div>
      </div>
    </nav>
  );
}
